import { render } from "./TagsContainer.vue?vue&type=template&id=f3f47b02&scoped=true"
import script from "./TagsContainer.vue?vue&type=script&lang=js"
export * from "./TagsContainer.vue?vue&type=script&lang=js"

import "./TagsContainer.vue?vue&type=style&index=0&id=f3f47b02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3f47b02"]])

export default __exports__